/**
 * SDK constants and configuration values
 *
 * Contains project identifiers, region settings, and service name mappings
 * used throughout the SDK for API communication.
 */

/** Google Cloud project number for test environment */
export const TEST_PROJECT_NUMBER = '807417405111';

/** Google Cloud project number for production environment */
export const PRODUCTION_PROJECT_NUMBER = '664618474012';

/** Default region for all backend services */
export const REGION = 'us-central1';

/**
 * Mapping of service identifiers to their backend service names
 * Used for constructing API URLs and routing requests
 */
export const SERVICE_NAMES = {
  CURRICULUM: 'curriculum-service',
  FAVORITES: 'favorites-service',
  PROFILE: 'profile-service',
  PROGRESS: 'progress-service',
  SETTINGS: 'settings-service',
  STREAK: 'streak-service',
  WEBSOCKET: 'websocket-service',
} as const;
